import { bigQuery } from '@fiverr-private/obs';

/**
 * Reports a "test seen" event to BigQuery.
 * @param {String} experiment Experiment number.
 * @param {Number | String} group Experiment allocation group.
 * @param {Object} [enrichedReportData] Additional data to add to the report.
 */
const reportEvent = ({ experiment, group, enrichedReportData = {} }) => {
    bigQuery.send({
        type: 'test_seen',
        group: 'ab_test',
        ab_test: [
            {
                experiment: parseInt(experiment, 10),
                group: parseInt(group, 10),
            },
        ],
        ...enrichedReportData,
    });
};

export default reportEvent;
